import axios from 'axios';
import { setAlert } from './alert';
import { 
    GET_ALL_REFERRAL_LEDGER_REQUEST,
    GET_ALL_REFERRAL_LEDGER_SUCCESS,
    GET_REFERRAL_LEDGER_SUCCESS,
    GET_REFERRAL_LEDGER_STATS_SUCCESS,
    GET_USER_REFERRALS_SUCCESS,
    GET_USER_REFERRED_BY_SUCCESS,
    CREATE_REFERRAL_LEDGER_SUCCESS,
    UPDATE_REFERRAL_LEDGER_SUCCESS,
    DELETE_REFERRAL_LEDGER_SUCCESS,
    COMPLETE_REFERRAL_SUCCESS,
    CANCEL_REFERRAL_SUCCESS
} from './types';

const API_URL = process.env.REACT_APP_SERVER_API_URL;

// GET all Referral Ledger Entries
export const getAllReferralLedger = (filters = {}) => async dispatch => {
    dispatch({
        type: GET_ALL_REFERRAL_LEDGER_REQUEST,
        payload: true
    });

    try {
        const queryParams = new URLSearchParams();
        
        // Add filters to query params
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                queryParams.append(key, filters[key]);
            }
        });

        const res = await axios.get(`${API_URL}/referral-ledger?${queryParams.toString()}`);
        
        if (res.data.success) {
            dispatch({
                type: GET_ALL_REFERRAL_LEDGER_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch referral ledger entries', 'danger'));
    }
};

// Get Referral Ledger by ID
export const getReferralLedger = id => async dispatch => {
    try {
        const res = await axios.get(`${API_URL}/referral-ledger/${id}`);
        
        if (res.data.success) {
            dispatch({
                type: GET_REFERRAL_LEDGER_SUCCESS,
                payload: res.data.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch referral ledger entry', 'danger'));
    }
};

// Get Referral Statistics
export const getReferralStats = (filters = {}) => async dispatch => {
    try {
        const queryParams = new URLSearchParams();
        
        // Add filters to query params
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
                queryParams.append(key, filters[key]);
            }
        });

        const res = await axios.get(`${API_URL}/referral-ledger/stats?${queryParams.toString()}`);
        
        if (res.data.success) {
            dispatch({
                type: GET_REFERRAL_LEDGER_STATS_SUCCESS,
                payload: res.data.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch referral statistics', 'danger'));
    }
};

// Get User Referrals (as Referrer)
export const getUserReferrals = (userId) => async dispatch => {
    try {
        const res = await axios.get(`${API_URL}/referral-ledger/user/${userId}/referrals`);
        
        if (res.data.success) {
            dispatch({
                type: GET_USER_REFERRALS_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch user referrals', 'danger'));
    }
};

// Get User Referred By (as Referee)
export const getUserReferredBy = (userId) => async dispatch => {
    try {
        const res = await axios.get(`${API_URL}/referral-ledger/user/${userId}/referred-by`);
        
        if (res.data.success) {
            dispatch({
                type: GET_USER_REFERRED_BY_SUCCESS,
                payload: res.data
            });
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to fetch user referred by data', 'danger'));
    }
};

// Create Referral Ledger Entry
export const createReferralLedger = (formData) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.post(`${API_URL}/referral-ledger`, formData, config);
        
        if (res.data.success) {
            dispatch({
                type: CREATE_REFERRAL_LEDGER_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert('Referral ledger entry created successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to create referral ledger entry', 'danger'));
    }
};

// Update Referral Ledger Entry
export const updateReferralLedger = (id, formData) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.put(`${API_URL}/referral-ledger/${id}`, formData, config);
        
        if (res.data.success) {
            dispatch({
                type: UPDATE_REFERRAL_LEDGER_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert('Referral ledger entry updated successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to update referral ledger entry', 'danger'));
    }
};

// Complete Referral
export const completeReferral = (id, formData) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.put(`${API_URL}/referral-ledger/${id}/complete`, formData, config);
        
        if (res.data.success) {
            dispatch({
                type: COMPLETE_REFERRAL_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert('Referral completed successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to complete referral', 'danger'));
    }
};

// Cancel Referral
export const cancelReferral = (id, formData) => async dispatch => {
    const config = {
        headers: {
            'Content-Type': 'application/json'
        }
    };

    try {
        const res = await axios.put(`${API_URL}/referral-ledger/${id}/cancel`, formData, config);
        
        if (res.data.success) {
            dispatch({
                type: CANCEL_REFERRAL_SUCCESS,
                payload: res.data.data
            });
            dispatch(setAlert('Referral cancelled successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to cancel referral', 'danger'));
    }
};

// Delete Referral Ledger Entry
export const deleteReferralLedger = (id) => async dispatch => {
    try {
        const res = await axios.delete(`${API_URL}/referral-ledger/${id}`);
        
        if (res.data.success) {
            dispatch({
                type: DELETE_REFERRAL_LEDGER_SUCCESS,
                payload: id
            });
            dispatch(setAlert('Referral ledger entry deleted successfully', 'success'));
            return res.data;
        } else {
            dispatch(setAlert(res.data.error, 'danger'));
        }
    } catch (err) {
        dispatch(setAlert('Failed to delete referral ledger entry', 'danger'));
    }
};

const convertReferralLedgerToCSV = (entries) => {
    if (!entries || entries.length === 0) return '';
    const headers = [
        'Referral ID', 'Status', 'Referrer Name', 'Referrer Phone', 'Referee Name', 'Referee Phone',
        'Referrer Cans', 'Referee Cans', 'Total Cans', 'Trigger Order', 'Created At', 'Completed At'
    ];

    const escapeCSV = (val) => {
        if (val === null || val === undefined) return '""';
        return `"${String(val).replace(/"/g, '""')}"`;
    };
    const formatDate = (val) => escapeCSV(val ? new Date(val).toLocaleString() : '');

    const rows = entries.map(e => [
        escapeCSV(e.referralId),
        escapeCSV(e.status),
        escapeCSV(e.referrerName),
        escapeCSV(e.referrerPhone),
        escapeCSV(e.refereeName),
        escapeCSV(e.refereePhone),
        escapeCSV(e.referrerCans),
        escapeCSV(e.refereeCans),
        escapeCSV(e.totalValue),
        escapeCSV(e.triggerOrderId),
        formatDate(e.createdAt),
        formatDate(e.completedAt)
    ]);

    return [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
};

// Export referral ledger entries as a filtered, unpaginated CSV download
export const exportReferralLedger = (filters = {}) => async dispatch => {
    try {
        const queryParams = new URLSearchParams();
        Object.keys(filters).forEach(key => {
            if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '' && key !== 'page') {
                queryParams.append(key, filters[key]);
            }
        });

        const res = await axios.get(`${API_URL}/referral-ledger/export?${queryParams.toString()}`);

        if (!res.data.success) {
            dispatch(setAlert(res.data.error || 'Failed to export referral ledger', 'danger'));
            return;
        }

        const csvContent = convertReferralLedgerToCSV(res.data.data.entries);
        if (!csvContent) {
            dispatch(setAlert('No referral ledger entries found to export', 'warning', 3000));
            return;
        }

        const blob = new Blob(['\uFEFF' + csvContent], { type: 'text/csv;charset=utf-8;' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = `referral-ledger-export-${new Date().toISOString().split('T')[0]}.csv`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(downloadUrl);
        dispatch(setAlert('Referral ledger exported successfully', 'success', 3000));
    } catch (err) {
        console.error('Error exporting referral ledger:', err);
        dispatch(setAlert('Failed to export referral ledger', 'danger'));
    }
};
